import { getConfig } from './storage'
import { ADICIONAIS_BOOLEAN, ADICIONAIS_QUANTIDADE } from '../data/adicionais'

function adicionaisTexto(adicionais) {
  if (!adicionais) return ''
  const r = []
  ADICIONAIS_BOOLEAN.forEach(({ key, label })    => { if (adicionais[key])      r.push(label) })
  ADICIONAIS_QUANTIDADE.forEach(({ key, label }) => { if (adicionais[key] > 0)  r.push(`${label}: ${adicionais[key]}`) })
  return r.join(' | ')
}

function formatDate(d) {
  if (!d) return ''
  try { return new Date(d + 'T12:00:00').toLocaleDateString('pt-BR') } catch { return d }
}

function formatCurrency(v) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0)
}

/**
 * Envia o pedido para o Google Apps Script que o appenda na planilha mãe.
 * Usa mode: 'no-cors' — o script recebe os dados mesmo sem retornar resposta CORS.
 */
export async function sincronizarComGoogleSheets(pedido) {
  const { googleSheetsUrl } = getConfig()
  if (!googleSheetsUrl) return { ok: false, motivo: 'URL não configurada' }

  const rows = pedido.moveis.map((m, i) => ({
    numero:       pedido.numero,
    criadoEm:     pedido.criadoEm ? new Date(pedido.criadoEm).toLocaleDateString('pt-BR') : '',
    clienteNome:  pedido.cliente?.nome || '',
    documento:    pedido.cliente?.documento || '',
    tipoDoc:      pedido.cliente?.tipoDocumento || '',
    icms:         pedido.cliente?.contribuinteICMS === 'sim' ? 'Contribuinte ICMS' : pedido.cliente?.tipoDocumento === 'CNPJ' ? 'Não contribuinte' : '',
    contato:      pedido.cliente?.contato || '',
    email:        pedido.cliente?.email || '',
    endereco:     pedido.cliente?.endereco || '',
    prazo:        formatDate(pedido.prazo),
    status:       pedido.status?.replace('_', ' ') || '',
    itemNum:      i + 1,
    modelo:       m.modelo || '',
    cor:          m.cor || '',
    comprimento:  m.comprimento || '',
    altura:       m.altura || '',
    profundidade: m.profundidade || '',
    adicionais:   adicionaisTexto(m.adicionais),
    observacoes:  m.observacoes || '',
    preco:        m.preco || 0,
    totalPedido:  i === 0 ? (pedido.valorTotal || 0) : '',
  }))

  const payload = JSON.stringify({ pedido: rows })

  try {
    await fetch(googleSheetsUrl, {
      method:  'POST',
      mode:    'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body:    payload,
    })
    return { ok: true }
  } catch (err) {
    console.error('[GoogleSheets] Erro ao sincronizar:', err)
    return { ok: false, motivo: err.message }
  }
}

/**
 * Código do Google Apps Script para colar no editor de script da planilha.
 * Disponível como string para exibir na tela de Config.
 */
export const APPS_SCRIPT_CODE = `// ─────────────────────────────────────────────────
// MINI Marcenaria — Planilha Mãe de Pedidos
// Cole este código em Extensões > Apps Script
// Depois: Implantar > Novo app da Web
//   Executar como: Eu mesmo
//   Quem tem acesso: Qualquer pessoa
// Copie a URL gerada e cole em Config > Google Sheets
// ─────────────────────────────────────────────────

const SHEET_NAME = 'Pedidos';

const CABECALHO = [
  'Nº Pedido','Data','Cliente','Documento','Tipo Doc','ICMS',
  'Contato','Email','Endereço','Prazo','Status',
  'Item Nº','Modelo','Cor','Compr.(cm)','Alt.(cm)','Prof.(cm)',
  'Adicionais','Observações','Preço (R$)','Total Pedido (R$)'
];

function doPost(e) {
  try {
    var data    = JSON.parse(e.postData.contents);
    var rows    = data.pedido;
    var ss      = SpreadsheetApp.getActiveSpreadsheet();
    var sheet   = ss.getSheetByName(SHEET_NAME);

    if (!sheet) {
      sheet = ss.insertSheet(SHEET_NAME);
    }

    // Cria cabeçalho se a planilha estiver vazia
    if (sheet.getLastRow() === 0) {
      sheet.appendRow(CABECALHO);
      sheet.getRange(1, 1, 1, CABECALHO.length)
        .setBackground('#111111')
        .setFontColor('#F5C200')
        .setFontWeight('bold');
      sheet.setFrozenRows(1);
    }

    // Adiciona uma linha por item do pedido
    rows.forEach(function(r) {
      sheet.appendRow([
        r.numero, r.criadoEm, r.clienteNome, r.documento, r.tipoDoc, r.icms,
        r.contato, r.email, r.endereco, r.prazo, r.status,
        r.itemNum, r.modelo, r.cor, r.comprimento, r.altura, r.profundidade,
        r.adicionais, r.observacoes, r.preco,
        r.totalPedido !== '' ? r.totalPedido : ''
      ]);
    });

    return ContentService
      .createTextOutput(JSON.stringify({ success: true }))
      .setMimeType(ContentService.MimeType.JSON);

  } catch(err) {
    return ContentService
      .createTextOutput(JSON.stringify({ success: false, error: err.toString() }))
      .setMimeType(ContentService.MimeType.JSON);
  }
}
`
